import _ from "lodash";
import TemplateDialog from "./TemplateDialog";
import { useApi } from "../../../../utils/hooks";
import { toHydratedItems } from "./utils";

const TemplateUpdater = ({ setTemplates, template, ...props }) => {
  const title = "Editar plantilla";
  const buttonText = "Actualizar";
  const api = useApi();

  const updateTemplates = (template) => {
    setTemplates((prev) => {
      const index = _.findIndex(prev, { id: template.id });
      prev[index] = template;
      return prev;
    });
  };
  // Mismo motivo que en Create.jsx: la API devuelve `content` crudo, no `items`
  // hidratado — se reconstruye con los `selectedItems` ya usados para el DTO.
  const updateTemplate = ({ originalTemplate, templateDto, selectedItems }) =>
    api
      .updateTemplate(originalTemplate.id, templateDto)
      .then((template) => ({ ..._.omit(template, "content"), items: toHydratedItems(selectedItems) }))
      .tap(updateTemplates);

  return (
    <TemplateDialog
      onSubmit={updateTemplate}
      title={title}
      buttonText={buttonText}
      originalTemplate={template}
      {...props}
    />
  );
};

export default TemplateUpdater;
